import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Layout from "../components/Landing/Layout";
import HeroSection from "../components/Landing/HeroSection";
import BlogGrid from "../components/Landing/BlogGrid";
import About from "../components/Landing/About";
import DoctorProfile from "../components/Landing/DoctorProfile";

const Visible = () => {
  // Section Scrolling Refs
  const blogsRef = useRef(null);
  const aboutRef = useRef(null);
  const doctorRef = useRef(null);

  const sectionRefsMap = {
    blogsRef,
    aboutRef,
    doctorRef,
  };

  const [activeSection, setActiveSection] = useState("blogsRef");
  const [doctorBlogs, setDoctorBlogs] = useState([]);

  // Fetch blogs posted by doctors
  useEffect(() => {
    axios
      .get("/api/doctor/blogs/public")
      .then((res) => setDoctorBlogs(res.data.blogs || []))
      .catch((err) => {
        console.error("Could not fetch public doctor blogs:", err);
        setDoctorBlogs([]);
      });
  }, []);

  // Smooth Scrolling Handler
  const handleNavClick = (sectionKey) => {
    setActiveSection(sectionKey);
    const ref = sectionRefsMap[sectionKey];
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Layout onNavClick={handleNavClick} activeSection={activeSection}>
      {/* Top Split-Screen Hero */}
      <HeroSection />

      {/* Secondary Articles & Physiotherapy Guides */}
      <div ref={blogsRef}>
        <BlogGrid doctorBlogs={doctorBlogs} />
      </div>

      {/* Clinic About Section */}
      <div ref={aboutRef}>
        <About />
      </div>

      {/* Dr. Monika Sharma Profile */}
      <div ref={doctorRef}>
        <DoctorProfile />
      </div>
    </Layout>
  );
};

export default Visible;
